<template>
  <li class="dropdownItem dropdownItem__customerInfo">
    <a
      class="dropdownItem__toggle user-profile dropdown-toggle"
      href="javascript:;"
      data-toggle="dropdown"
      aria-expanded="true"
    >
      公告/司機訊息
      <span class="dropdownItem__icon fa fa-angle-down"></span>
    </a>
    <ul class="dropdown-menu dropdown-usermenu pull-right">
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/board'"
          v-if="permissionAnnouncement"
        >
          車隊內部公告
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <!--@click.native="$emit('refresh')" -->
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/messageList'"
          v-if="permissionDriverMessage"
        >
          傳送訊息紀錄
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  props: ['permissionDriverMessage', 'permissionAnnouncement'],
}
</script>

<style lang="scss" scoped>
@import 'src/scss/_dropdownItem.scss';
</style>



// WEBPACK FOOTER //
// src/components/dropDown/DropdownMessages.vue